import React from "react";
import { useVeltClient } from "../context";
/**
 * @beta This hook is in beta
 */
export function useClient() {
    var client = useVeltClient().client;
    var _a = React.useState(), veltClient = _a[0], setVeltClient = _a[1];
    React.useEffect(function () {
        if (!client || veltClient)
            return;
        setVeltClient(client);
    }, [client, setVeltClient, veltClient]);
    return veltClient;
}
/**
 * @beta This hook is in beta
 */
export function useIdentify(user, userOptions) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.identify(user, userOptions);
    }, [client]);
}
function useUpdateUser(user) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.updateUser(user);
    }, [client]);
}
function useSignOutUser() {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.signOutUser();
    }, [client]);
}
/**
 * @beta This hook is in beta
 */
export function useSetDocumentId(documentId) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.setDocumentId(documentId);
    }, [client]);
}
function useGetDocumentId() {
    var client = useVeltClient().client;
    var _a = React.useState(), documentId = _a[0], setDocumentId = _a[1];
    React.useEffect(function () {
        if (!client || documentId)
            return;
        var loadedDocumentId = client.getDocumentId();
        setDocumentId(loadedDocumentId);
    }, [client, setDocumentId, documentId]);
    return documentId;
}
/**
 * @beta This hook is in beta
 */
export function useSetLocation(location) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.setLocation(location);
    }, [client]);
}
/**
 * @beta This hook is in beta
 */
export function useAddLocation(location) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.addLocation(location);
    }, [client]);
}
